import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

// The in-app debug mesh viewer now lives in Storybook (ENG-783) — see the
// `Mesh Viewer/DebugMeshViewer` stories. This route is kept as a redirect so
// existing links and bookmarks keep working: on localhost it opens the local
// Storybook (`pnpm storybook`, :6006); anywhere else it opens the deployed
// (access-controlled) GitHub Pages Storybook. Lands on the Jet Engine Bracket
// story, which auto-loads a volume mesh.
const STORY_PATH =
  '/?path=/story/mesh-viewer-debugmeshviewer--jet-engine-bracket';
const LOCAL_STORYBOOK = 'http://localhost:6006';
// Access-controlled GitHub Pages deploy of Storybook. This obscured URL is the
// implicit output of the `actions/deploy-pages` step in
// `.github/workflows/storybook-pages.yml` and lives nowhere else, so that
// workflow is the source of truth if it ever changes.
const PAGES_STORYBOOK = 'https://special-doodle-92gn5z4.pages.github.io';

function storybookUrl(): string {
  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return (isLocal ? LOCAL_STORYBOOK : PAGES_STORYBOOK) + STORY_PATH;
}

function DebugViewerRedirect() {
  useEffect(() => {
    // replace() so the dead debug route doesn't linger in history.
    window.location.replace(storybookUrl());
  }, []);

  return (
    <div className="flex h-full w-full items-center justify-center bg-background text-muted-foreground">
      Opening the mesh viewer in Storybook…
    </div>
  );
}

export const Route = createFileRoute('/_app/debug/viewer/')({
  component: DebugViewerRedirect,
});
